import request from '@/utils/request'
import base from "@/api/base";

export default {
    // 新增面料适用
    add: params => request.post(`${base.baseUrl}/yyyhao-cloud-member/member/saveFabricApply`, params),
    //查询面料适用
    get: params => request.get(`${base.baseUrl}/yyyhao-cloud-member/member/getFabricApplyList`, params),
    //修改面料适用
    update: params => request.post(`${base.baseUrl}/yyyhao-cloud-member/member/updateFabricApply`, params),
    //删除面料适用
    del: params => request.post(`${base.baseUrl}/yyyhao-cloud-member/member/deleteFabricApply`, params),
}